import styles from './UnauthenticatedLayout.module.css'

export const authStyles = styles
